export class TextUseReferenceModel {
    public textUseCode: string;
    public textUseName: string;
    public maximumLength: number;
}